export type ClassValue = string | false | null | undefined;
export function cn(...parts: ClassValue[]): string { return parts.filter(Boolean).join(" "); }
export type ValidationStatus = "present" | "absent" | "divergent" | "extra";
export const STATUS_LABEL: Record<ValidationStatus, string> = {
  present: "Presente", absent: "Ausente", divergent: "Divergente", extra: "Extra",
};
export const STATUS_COLOR_VAR: Record<ValidationStatus, string> = {
  present: "var(--color-status-present)", absent: "var(--color-status-absent)",
  divergent: "var(--color-status-divergent)", extra: "var(--color-status-extra)",
};
const PALETTE = ["#00d177","#30c2ff","#fd650d","#eb5757","#b388ff",
  "#ffd166","#06d6a0","#ef476f","#118ab2","#8d99ae","#f4a261","#2a9d8f"];
export function colorForKey(key: string): string {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
